<template>
  <b-overlay
    :show="isLoading"
    rounded="sm"
  >
    <v-select
      v-model="selectedPlan"
      :options="planesList"
      :placeholder="isLoading ? 'Cargando ...' : 'Seleccione'"
      label="nombre"
      :clearable="true"
      class="w-100"
    />
  </b-overlay>
</template>

<script>
import {
  ref, onMounted, watch,
} from '@vue/composition-api'
import vSelect from 'vue-select'
import { BOverlay } from 'bootstrap-vue'
// import { getPlanesCached } from '@core/utils/services/planesCache'
import { fillPlanes } from './useWebService'

export default {
  components: {
    vSelect,
    BOverlay,
  },
  props: {
    planId: { type: [Number, null], default: null }, // 🔥 padre manda solo ID
    isDisabled: Boolean,
    liberarPlanes: { type: Boolean, default: false },
    autoSelectFirst: { type: Boolean, default: true },
  },

  setup(props, { emit }) {
    const planesRaw = ref([])
    const selectedPlan = ref(null)
    const isLoading = ref(false)

    // ===== FILTER =====
    // const planesList = computed(() => {
    //   if (props.nivelFilter == null) return planesRaw.value // mostrar todo

    //   return planesRaw.value.filter(p => p.nivel === props.nivelFilter)
    // })
    // const planesList = computed(() => {
    //   if (!props.nivelFilter) return planesRaw.value.filter(p => p.nivel !== 1)
    //   return planesRaw.value.filter(p => p.nivel === props.nivelFilter)
    // })
    // ================= AUTO SELECT =================
    // const getDefaultPlan = () => {
    //   if (!planesRaw.value.length) return null
    //   return [...planesRaw.value].sort((a, b) => a.id - b.id)[0]
    // }
    const getDefaultPlan = () => {
      if (!planesRaw.value.length) return null
      return planesRaw.value.reduce((max, item) => (item.id > max.id ? item : max))
    }

    // ===== FETCH =====
    const fetchPlanes = async () => {
      isLoading.value = true
      // planesRaw.value = await getPlanesCached(fillPlanes)
      planesRaw.value = await fillPlanes(props.liberarPlanes)
      isLoading.value = false
    }

    // ===== SYNC FROM PARENT (planId) =====
    const syncFromParent = () => {
      if (!planesRaw.value.length) return

      if (props.planId != null) {
        selectedPlan.value = planesRaw.value.find(p => p.id === props.planId) || null
        return
      }

      // auto default
      if (props.autoSelectFirst && !selectedPlan.value) {
        selectedPlan.value = getDefaultPlan()
      }
    }

    // ===== EMIT TO PARENT =====
    watch(selectedPlan, plan => {
      if (!plan) {
        emit('update:planId', null)
        emit('change', null)
        return
      }

      emit('update:planId', plan.id)
      emit('change', { id: plan.id, nivel: plan.nivel })
    })

    watch(() => props.planId, syncFromParent)
    watch(() => props.nivelFilter, syncFromParent)

    onMounted(async () => {
      await fetchPlanes()
      syncFromParent()
    })

    return { planesList: planesRaw, selectedPlan, isLoading }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
